import React from 'react';
import { Prompt } from 'react-router-dom';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DailyRollupView from './DailyRollupView';
import DailyTimecardView from './DailyTimecardView';
import MessagesView from './MessagesView';
import OtherPaymentsView from './OtherPaymentsView';
import TimeclocksView from './TimeclocksView';
import summaryListModel from './SummaryListModel';
import dailyRollupModel from './DailyRollupModel';
import dailyTimecardModel from './DailyTimecardModel';
import otherPaymentsModel from './OtherPaymentsModel';
import timeclocksModel from './TimeclocksModel';
import timecardModel from './TimecardModel';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    '& h5': {
      fontWeight: '500',
      fontSize: '1.35rem',
    },
  },
  scrollablePart: {
    overflow: 'auto',
  },
  savingBlocker: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: 100,
    opacity: '0.7',
    backgroundColor: 'gray',
    cursor: 'wait',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '72px',
      color: 'lightgray',
    },
  },
  noResults: {
    margin: '10px',
  },
  loading: {
    height: '100%',
    cursor: 'wait',
    fontStyle: 'italic',
    margin: '10px',
  },
});

interface ITimecardProps {
  className?: string;
}

type TimecardProps = WithStyle<ReturnType<typeof styles>, ITimecardProps>;

class TimecardView extends React.PureComponent<TimecardProps> {
  constructor(props: TimecardProps) {
    super(props);
  }

  componentDidMount() {
    timecardModel.startMonitoringTimecardChanges();
  }

  componentWillUnmount() {
    timecardModel.stopMonitoringTimecardChanges();
  }

  ignoreClick() {}

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe
          render={() => {
            const employee = summaryListModel.selectedEmployee;
            const saving = employee?.saving;

            return saving ? (
              <div className={classes.savingBlocker} onClick={this.ignoreClick}>
                <span>Saving...</span>
              </div>
            ) : null;
          }}
        />

        <Observe
          render={() => {
            const employee = summaryListModel.selectedEmployee?.name;
            return (
              <Prompt
                when={timecardModel.canSave()}
                message={(_location) => `There are unsaved changes for ${employee}.\nDo you wish to return and save your changes?`}
              />
            );
          }}
        />

        <Observe
          render={() => {
            if (summaryListModel.selectedEmployee) {
              return (
                <div className={classes.scrollablePart}>
                  <DailyRollupView model={dailyRollupModel} />
                  <DailyTimecardView model={dailyTimecardModel} />
                  <OtherPaymentsView model={otherPaymentsModel} />
                  <TimeclocksView model={timeclocksModel} />
                  <Observe
                    render={() => (
                      <MessagesView
                        title="Timecard Messages"
                        titleVariant="h5"
                        effective={() => timecardModel.rollupModel.selectedRolledUpTimecard?.earnedDate}
                        messages={timecardModel.allSelectedEmployeeMessages}
                        viewOnly={timecardModel.viewOnly}
                        onClick={(message) => timecardModel.handleMessageSelected(message)}
                      />
                    )}
                  />
                </div>
              );
            }
            return summaryListModel.pagingModel.loading ? (
              <div className={classes.loading} />
            ) : summaryListModel.employeeCount ? (
              <div>
                <Typography className={this.props.classes.noResults} variant="h3">
                  No employee selected
                </Typography>
                <Typography className={this.props.classes.noResults} variant="h5">
                  Select an employee from the list to view their timecards
                </Typography>
              </div>
            ) : (
              <div>
                <Typography className={this.props.classes.noResults} variant="h3">
                  No results available
                </Typography>
                <Typography className={this.props.classes.noResults} variant="h5">
                  Return to search for timecards that meet your criteria
                </Typography>
              </div>
            );
          }}
        />
      </div>
    );
  }
}

export default withStyles<ITimecardProps>(styles, TimecardView);
